export enum FilterTypeValue {
  NO_PARTICIPANTS,
  ALL_OPEN,
  ALL_CLOSED,
}
export enum FilterOrderValue {
  LAST_OPENED_AT = 'lastOpenedAt',
  UPDATED_AT = 'updatedAt',
}

export interface FilterTypeOption {
  value: FilterTypeValue
  label: string
}
export interface FilterOrderOption {
  value: FilterOrderValue
  label: string
}

export const filterTypeOptions: FilterTypeOption[] = [
  { value: FilterTypeValue.NO_PARTICIPANTS, label: 'open conversations with no participants' },
  { value: FilterTypeValue.ALL_OPEN, label: 'all open conversations' },
  { value: FilterTypeValue.ALL_CLOSED, label: 'all closed conversations' },
]
export const filterOrderOptions: FilterOrderOption[] = [
  { value: FilterOrderValue.LAST_OPENED_AT, label: 'newest conversations' },
  { value: FilterOrderValue.UPDATED_AT, label: 'newest messages' },
]
